import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DeleteButton, EditButton, MessageBox } from "../../components";
import { useGetContentQuery } from "../../store";
import Skeleton from "react-loading-skeleton";

const ViewContent = ({ type, url, text, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const { isLoading, isError, error, data, refetch } = useGetContentQuery(type);

  console.log(data);
  return (
    <Card>
      {isError ? (
        <MessageBox variant="danger">{error?.data?.error?.message}</MessageBox>
      ) : isLoading ? (
        <Skeleton count={5} height={40} />
      ) : (
        <>
          <Card.Header>
            {data?.content?.content ? (
              <>
                <h3 className="mb-0 d-inline">{text}</h3>
                <div className="float-end">
                  <EditButton onClick={onEdit} />
                  {/* <DeleteButton onClick={onDelete} /> */}
                </div>
              </>
            ) : (
              <Button
                onClick={() => navigate(url)}
                type="success"
                className="btn btn-primary btn-block mt-1"
              >
                Add {text}
              </Button>
            )}
          </Card.Header>
          <Card.Body>
            {data?.content && (
              <div
                style={{ maxHeight: "50vh", overflowY: "auto" }}
                dangerouslySetInnerHTML={{ __html: data?.content?.content }}
              />
            )}
          </Card.Body>
        </>
      )}
    </Card>
  );
};

export default ViewContent;
